import type { AppManifest } from '@api/apps';

/** Only an explicit `false` says the page never starts a run; older manifests have no flag and do. */
export const usesAgent = (manifest: Pick<AppManifest, 'usesAgent'> | null | undefined): boolean =>
  manifest?.usesAgent !== false;
